module.exports = __webpack_public_path__ + "assets/img/Ic-WeChat.ef615315.svg";